export enum CurrencyUi {
  EUR = "€",
  GBP = "£",
}
